import React from 'react'
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import MoodBadIcon from '@mui/icons-material/MoodBad';

const  worklistFlag = (props)=> {
  return (
    <div>
      {props.flag == "bad" ? (
         
         <MoodBadIcon style={{ color: 'red' }} 
         onClick ={()=>{
          console.log("issues",props.flagErrors)
          props.displayIssues(props.flagErrors)
         }}
         />
      ):(
        <InsertEmoticonIcon  />
      )}
     
      </div>
  )
}

export default worklistFlag